import { CjsLogin, LinkOptions } from "@cervval.js/client-auth/src/components/login/login.component";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { CustomElement, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { AuthErrorCode } from "@cervval.js/common-auth/src/auth.errors";
import { AuthInfos } from "@cervval.js/common-auth/src/authRoutes";
import { APP_SERVICE, AppService, ERROR_MESSAGE_SERVICE } from "@cervval.js/common/services";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { Locale } from "@cervval.js/common/src/models/locale.model";
import { DefaultErrorMessageService } from "@cervval.js/common/src/services/errorMessage.impl/default.errorMessage.service";
import { getLogConsole } from "@cervval.js/common/src/services/log.service";
import { capitalizeFirstLetter } from "@cervval.js/common/src/tools/string.tools";
import { NeoplanCustomErrors } from "@neoplan/apps~planning-common/src/commonUtils/constants/neoplanErrors";
import { LOCALES } from "@neoplan/common-shared/src/i18n/const/i18nConst";
import { LOGIN_CLIENT_MAIN_SERVICE, LoginClientMainService } from "../../services/loginClientMainService.service";
import { I18nType, i18n } from "./i18n/i18n";

@CustomElement({
    name: "login-page",
    style: require("./login.page.scss"),
    template: require("./login.page.html"),
    i18n
})
export class LoginPage extends WebPageComponent<I18nType> {

    @Injected(APP_SERVICE)
    protected readonly _app!: AppService;

    @Injected(ERROR_MESSAGE_SERVICE)
    protected readonly _errorMessageService!: DefaultErrorMessageService<string>;

    @Injected(LOGIN_CLIENT_MAIN_SERVICE)
    private _mainService!: LoginClientMainService;

    @TypedHtmlElements()
    public components!: {
        imageContainer: HTMLDivElement,
        // borderLeftContainer: HTMLDivElement,
        borderRightContainer: HTMLDivElement,
        loginContainer: HTMLDivElement
    };

    private _loginComponent: CjsLogin = new CjsLogin({
        login: this._login.bind(this)
    });

    /**
     * init: first time the item is inserted into DOM
     */
    public override init(): Promise<void> {
        this.classList.add("d-flex", "flex-row");
        // FIXME REMOVE ME LATER
        this._app.setLocale(LOCALES.EN as unknown as Locale);

        this._registerMessages();
        return this._mainService.authInfosRoutes.getAuthInfos()
            .then((authInfos: AuthInfos) => {
                this._loginComponent = new CjsLogin(
                    {
                        appName: authInfos.appDisplayName,
                        appLogoUrl: authInfos.appLogoUrl,
                        login: this._login.bind(this),
                        ssoOptions: authInfos.singleSignOnOptions?.map((s) => {
                            const linkOptions: LinkOptions = {
                                iconCss: s.iconCss,
                                text: capitalizeFirstLetter(s.text),
                                tooltip: s.text,
                                callback: () => {
                                    window.location.href = s.url;
                                    return Promise.resolve(undefined);
                                }
                            };
                            return linkOptions;
                        })
                    }
                );
                this.components.loginContainer.append(this._loginComponent);
            }).catch((err) => {
                getLogConsole().error(err);
            });
    }

    /** Perform login */
    private _login(login: string, password: string): Promise<void> {
        return this._mainService.loginRoutes.formLogin(
            { login, password },
            {
                doNotLogErrors: true,
                doNotShowDialogOnErrors: true
            }
        ).then((loginResult) => {
            if (loginResult.redirectAfterLogin) {
                window.location.href = loginResult.redirectAfterLogin;
            } else {
                window.location.href = "..";
            }
        });
    }

    /** Register error messages */
    private _registerMessages(): void {
        const errorToHandles: number[] = [AuthErrorCode.NO_LOGIN_DATA, NeoplanCustomErrors.NO_PERMISSIONS];
        const messages: Record<string, Record<number, string>> = {};
        messages[this._app.lang] = {};
        for (const errorCode of errorToHandles) {
            messages[this._app.lang][errorCode] = `${this.i18n.error[errorCode as keyof I18nType["error"]]} - ${this.i18n.error.adminContact}`;
        }
        this._errorMessageService.registerErrorMessages(messages);
    }
}